import React from 'react';
import { Grid, GridColumn, GridProps } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { formatAmount } from 'utils/common';

export const GridDetailComponent = ({ props, colSpan = 10 }) => {
  const { subLimits, currency } = props.dataItem; //sublimits from dataItem will be available here

  const columns = [
    {
      field: '',
      title: '',
      width: 60,
    },
    {
      field: 'CategoryID',
      title: 'FACILITY CATEGORY',
      width: 130,
      cell: e => <td>{e.dataItem?.facilityCategory?.name ?? ''}</td>,
    },
    {
      field: 'type',
      title: 'TYPE',
      width: 100,
      cell: e => <td>{e.dataItem?.sublimitType?.name ?? ''}</td>,
    },
    {
      field: 'interestRate',
      title: 'INTEREST RATE',
      width: 100,
      cell: e => <td>{e.dataItem.interestRate ?? 0}%</td>, // Formatting interest rate as percentage
    },
    {
      field: 'amount',
      title: 'AMOUNT',
      width: 100,
      cell: e => (
        <td>
          {currency?.name} {e.dataItem.amount?.toLocaleString() ?? 0}
        </td>
      ), // Formatting with currency suffix
    },
    {
      field: 'utilizedAmount',
      title: 'UTILIZED AMOUNT',
      width: 150,
      cell: e => (
        <td>
          {e.dataItem.utilizedAmount
            ? `${currency?.name} ${formatAmount(e.dataItem.utilizedAmount)}`
            : `${currency?.name} 0`}
        </td>
      ), // Formatting with currency suffix
    },
    {
      field: 'utilizedRate',
      title: 'UTILIZED RATE',
      width: 130,
      cell: e => <td>{e.dataItem?.utilizationRate?.toLocaleString() ?? 0}%</td>, // Formatting utilized rate as percentage
    },
    {
      field: 'remainingBalance',
      title: 'REMAINING BALANCE',
      width: 150,
      cell: e => (
        <td>
          {e.dataItem.balance
            ? `${currency?.name} ${formatAmount(e.dataItem.balance)}`
            : 0}
        </td>
      ), // Formatting with currency suffix
    },
  ];
  return (
    <>
      <tr className="detail-row-container">
        <CustomTd colSpan={colSpan}>
          <CustomGrid className="row-expanded-grid" data={subLimits ?? []}>
            {columns?.map((column, index) => {
              return <GridColumn key={index} {...column} />;
            })}
          </CustomGrid>
        </CustomTd>
      </tr>
    </>
  );
};
const CustomTd = styled.td`
  padding: 0 0 0 0 !important;
`;
const CustomGrid = styled(Grid)<GridProps & { children?: React.ReactNode }>`
  background: ${p => p.theme.expandedGridBg};
  .k-grid-header {
    border-bottom: 1px solid ${p => p.theme.expandedGridHeadBorder};
    .k-header {
      color: ${p => p.theme.expandedGridHeadColor};
      .k-cell-inner .k-link {
        color: ${p => p.theme.expandedGridHeadInnerColor} !important;
      }
      tr th:nth-last-child(1) {
        padding: 0px !important;
      }
    }
  }
  .k-grid-container {
    tbody {
      tr {
        &:nth-of-type(odd) {
          background: transparent;
        }
        &:nth-of-type(even) {
          background: ${p => p.theme.expandedGridEvenBg} !important;
        }
        td {
        }
      }
    }
  }
`;
